// Detailed services data for K. Pheiffer Construction

export const services = [
  {
    id: "tagarbejde",
    title: "Tagarbejde & Tagrenovering",
    shortDescription: "Et tæt og solidt tag er husets vigtigste beskyttelse. Vi udfører alt fra mindre reparationer til komplette tagudskiftninger.",
    description: "Et tæt og solidt tag er husets vigtigste beskyttelse mod det omskiftelige danske vejr. Hos K. Pheiffer Construction har vi stor erfaring med tagarbejde, uanset om det drejer sig om en mindre reparation, udskiftning af enkelte tagsten eller en komplet tagrenovering med nye tegl, undertag og isolering.",
    icon: "fa-regular fa-hammer",
    image: "https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/nyt-teglstenstag-m-zinktagrender.jpg",
    benefits: [
      "Lang levetid med certificerede kvalitetsmaterialer",
      "Forbedret isolering, der kan mærkes på varmeregningen",
      "Professionel rådgivning om materialevalg og æstetik",
      "Altid udført i fuld overensstemmelse med gældende byggeregler"
    ]
  },
  {
    id: "traeterrasser",
    title: "Træterrasser & Uderum",
    shortDescription: "Drømmer du om en smuk træterrasse? Vi designer og bygger skræddersyede terrasser i eksklusive og holdbare træsorter.",
    description: "Drømmer du om en smuk træterrasse, der forbinder huset med haven og skaber det perfekte uderum til de lune sommeraftener? Vi designer og opbygger skræddersyede træterrasser i eksklusive og slidstærke træsorter som lærk, thermo-ask, ipé eller klassisk trykimprægneret træ.",
    icon: "fa-regular fa-compass-drafting",
    image: "https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/tagterrasse-med-glashegn-5.jpg",
    benefits: [
      "Skræddersyet design, der passer perfekt til husets arkitektur",
      "Solidt underkonstruktionsarbejde, der sikrer en stabil terrasse i årtier",
      "Flotte detaljer som integrerede trapper, niveauer og skjulte skruer",
      "Rådgivning om vedligeholdelse og optimalt materialevalg"
    ]
  },
  {
    id: "vinduer-doere",
    title: "Udskiftning af Vinduer & Døre",
    shortDescription: "Nye vinduer og døre forbedrer indeklimaet, øger sikkerheden og reducerer dit energiforbrug markant.",
    description: "Nye vinduer og døre kan forvandle dit hus' udseende fuldstændigt, samtidig med at det forbedrer indeklimaet og reducerer dit energiforbrug markant. Vi monterer døre og vinduer fra førende danske producenter som VELFAC, Rationel og Outline, hvilket garanterer dig den bedste kvalitet.",
    icon: "fa-regular fa-window-maximize",
    image: "https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/vinduesmontering-i-nybyg-2.jpg",
    benefits: [
      "Mærkbar besparelse på varmeregningen fra dag ét",
      "Bedre indeklima med mindre træk og støj udefra",
      "Øget sikkerhed mod indbrud med moderne låsesystemer",
      "Minimal vedligeholdelse med moderne træ-alu løsninger"
    ]
  },
  {
    id: "totalrenovering",
    title: "Totalrenovering & Ombygning",
    shortDescription: "Vi styrer dit renoveringsprojekt sikkert i mål, uanset om du skal modernisere, flytte vægge eller udvide.",
    description: "Uanset om du har købt et ældre parcelhus, der trænger til en kærlig hånd, ønsker at flytte vægge for at skabe et moderne køkken-alrum, eller vil udnytte uudnyttede kvadratmeter på loftet, står vi klar. Vi påtager os gerne hovedentreprisen, så du kun skal forholde dig til én kontaktperson.",
    icon: "fa-regular fa-screwdriver-wrench",
    image: "https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/nybygget-arkitekthus-i-forskellige-niveauer.jpg",
    benefits: [
      "Én fast kontaktperson og fuld koordinering af alle faggrupper",
      "Overholdelse af tidsplaner og aftalte budgetter",
      "Kvalitetssikring i alle byggeriets faser",
      "Gennemførte løsninger med stor respekt for husets oprindelige sjæl"
    ]
  },
  {
    id: "facadearbejde",
    title: "Facadearbejde & Isolering",
    shortDescription: "Giv dit hus en flot facade, der beskytter mod vind og vejr, og forbedrer husets energiklasse.",
    description: "Giv dit hus en flot, moderne facade, der beskytter murværket mod vind og vejr. Vi udfører professionelt facadearbejde, herunder netpuds, facadeisolering og maling. En velisoleret og flot facade hæver ikke blot husets æstetiske værdi, men forbedrer også husets energiklasse og indeklima.",
    icon: "fa-regular fa-paint-roller",
    image: "https://assets.auxodev.dk/assets/cf131c5c-877c-4f32-8100-a69e4d795732/vandskuring-af-facade-2.jpg",
    benefits: [
      "Flot og moderne udtryk, der forvandler husets udseende",
      "Effektiv efterisolering, der beskytter mod kulde og fugt",
      "Forebygger revner, frostsprængninger og skimmel",
      "Hæver husets samlede markedsværdi og salgbarhed"
    ]
  }
];
